export default __webpack_public_path__ + "static/media/welcome-back.7e26128a.jpg";